const STORAGE_KEY = 'whatquiz_class_photo_trial_welcome';
const TTL_MS = 5 * 60 * 1000;

export const saveClassPhotoTrialWelcome = ({ triggerFeature, redirectPath } = {}) => {
  const trigger = String(triggerFeature || '');
  if (
    !trigger.includes('class_photo')
    && !trigger.includes('class_activity')
    && !trigger.includes('class_play')
    && !trigger.includes('hwp_doc')
  ) {
    return false;
  }
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify({
      redirectPath: redirectPath || '/events/class-photo',
      // 모달이 트리거별로 버튼을 바꾸기 위해 보관(예: hwp_doc → "이어서 편집하기").
      triggerFeature: trigger.slice(0, 60),
      expiresAt: Date.now() + TTL_MS,
    }));
    return true;
  } catch (_) {
    return false;
  }
};

const readWelcome = () => {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const value = JSON.parse(raw);
    if (!value?.expiresAt || Date.now() > value.expiresAt) return null;
    return value;
  } catch (_) {
    return null;
  }
};

/** 아직 소비되지 않은(곧 뜰) 환영 모달이 있는지. 페이지가 자동 이동과 모달 버튼 이동이 겹치지 않게 쓴다. */
export const hasClassPhotoTrialWelcomePending = () => Boolean(readWelcome());

export const consumeClassPhotoTrialWelcome = () => {
  const value = readWelcome();
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch (_) {
    // 무시
  }
  return value;
};
